import React from 'react'
import { Navigate, Link, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { isAdmin } from '../utils/adminCheck'

function AdminLayout() {
  const { user, loading } = useAuth()

  if (loading) {
    return <div className="loading">Loading...</div>
  }

  // Redirect non-admins to home
  if (!user || !isAdmin(user)) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="admin-layout">
      {/* Admin Navigation */}
      <div className="admin-nav">
        <h2>Admin Panel</h2>
        <nav className="admin-menu">
        <Link to="/admin" className="admin-menu-item">
            📊 Dashboard
        </Link>
        <Link to="/admin/add-lure" className="admin-menu-item">
            ➕ Add Lure
        </Link>
        <Link to="/admin/manage-lures" className="admin-menu-item">
            📝 Manage Lures
        </Link>
        <Link to="/admin/manage-brands" className="admin-menu-item">
            🏢 Manage Brands
        </Link>
        <Link to="/" className="admin-menu-item back-to-site">
            ← Back to Site
        </Link>
        <Link to="/admin/manage-complete-submissions" className="admin-menu-item">
          📦 Complete Lure Submissions
        </Link>
</nav>
      </div>

      {/* Admin Content Area */}
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  )
}

export default AdminLayout